import { Switch } from "@blueprintjs/core"
import React from "react"
import { useDispatch } from "react-redux"

import styles from "./TimeframeFilterSwitch.module.css"

import TitledHelpTooltip from "~/common/TitledHelpTooltip"

import { setShowOnlyScheduledInTimeframe } from "~/Planner/reducer2/peopleFilterSlice"
import { useAppSelector } from "~/hooks/redux"
import { setSetting } from "~/localsettings"

import { useSuperSearchConfig } from "../../SuperSearchContext"

export const TimeframeFilterSwitch = () => {
  const dispatch = useDispatch()
  const showOnlyScheduledInTimeframe = useAppSelector(
    (state) => state.plannerV2.peopleFilter.showOnlyScheduledInTimeframe,
  )

  const config = useSuperSearchConfig()

  if (!config.features.plannerTimeframeToggle) {
    return null
  }

  const toggleShowOnlyScheduledInTimeframe = () => {
    dispatch(setShowOnlyScheduledInTimeframe(!showOnlyScheduledInTimeframe))
    setSetting(
      "peopleFilterShowOnlyScheduledInTimeframe",
      !showOnlyScheduledInTimeframe,
    )
  }

  return (
    <div className={styles.switchContainer}>
      <TitledHelpTooltip
        title="People scheduled in timeframe"
        tooltipContent="Filters to people with scheduled assignments in the current planner timeframe."
      />
      <Switch
        checked={showOnlyScheduledInTimeframe}
        onChange={toggleShowOnlyScheduledInTimeframe}
        alignIndicator="right"
        style={{ margin: 0 }}
      />
    </div>
  )
}
